export const fmtMoney = (n, cur = "FCFA") => `${new Intl.NumberFormat("fr-FR").format(Math.round(n || 0))} ${cur}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");

const TONES = {
  blue: "bg-blue-50 text-blue-700 ring-blue-200",
  green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  amber: "bg-amber-50 text-amber-700 ring-amber-200",
  red: "bg-rose-50 text-rose-700 ring-rose-200",
  slate: "bg-slate-100 text-slate-600 ring-slate-200",
  violet: "bg-violet-50 text-violet-700 ring-violet-200",
};

export const QUOTE_STATUS = { nouveau: ["Reçu", "blue"], contacte: ["En étude", "violet"], qualifie: ["En étude", "violet"], opportunite: ["Proposition envoyée", "amber"], client: ["Accepté", "green"], perdu: ["Clôturé", "slate"] };
export const INVOICE_STATUS = { emise: ["À régler", "amber"], payee: ["Payée", "green"], en_retard: ["En retard", "red"], annulee: ["Annulée", "slate"] };
export const TICKET_STATUS = { ouvert: ["Ouvert", "blue"], en_cours: ["En cours", "violet"], en_attente_client: ["En attente de votre retour", "amber"], resolu: ["Résolu", "green"], ferme: ["Fermé", "slate"] };
export const PRIORITIES = { basse: "Basse", normale: "Normale", haute: "Haute", urgente: "Urgente" };

export function Pill({ map, value, testid }) {
  const [label, tone] = map[value] || [value, "slate"];
  return <span data-testid={testid} className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ring-1 ring-inset ${TONES[tone]}`}>{label}</span>;
}
